import React, { useState } from 'react'
import smartPhone from '../../Assests/Product/smart-phone.svg';
import smartRing from '../../Assests/Product/smartRing.svg';
import smartWatch from '../../Assests/Product/smartwatch.svg';
import empowerIphone from '../../Assests/Product/empowerIphonePNG.png';


import tablet from '../../Assests/Product/tablet.svg';
import "../../Styles/Contact.scss"

import '../../Styles/ProductTrackHealth.scss'

import plus from '../../Assests/ContactUs/plus.svg'
import cancel from '../../Assests/ContactUs/cancel.svg'

function EmpoweringCaregiverSupport() {
    const [openIndex, setOpenIndex] = useState(null);


    const questionsAndAnswers = [
        {
            question: "What features are included in the premium plan?",
            answer:
                "Premium plan includes personalized health insights, advanced food logging, activity tracking, caregiver collaboration, secure medical report uploads, and custom schedules.",
        },
        {
            question: "How secure is my data?",
            answer:
                "Your data is securely stored and encrypted to ensure your privacy. We are committed to maintaining the highest standards of data protection and comply with GDPR regulations.",
        },
        {
            question: "Can I cancel my subscription anytime?",
            answer:
                "You can cancel your subscription anytime and retain access to premium features until the end of the billing cycle.",
        },
        {
            question: "How can I track my progress with the app?",
            answer:
                "You can track your progress through personalized insights, activity logs, and health reports that update in real-time based on your entries. The app also provides visual progress charts to keep you informed.",
        },
        {
            question: "How do I update my personal information in the app?",
            answer:
                "You can easily update your personal information by going to the 'Profile' section in the app settings and editing your details.",
        },
    ];

    const toggleAccordion = (index) => {
        setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    return (
        <>
            <div className='empowercaregiver'>
                {/* <div className='text-center mt-5'>
                    <img className='responsiveImg-empowering' src={empoweringCaregiver} alt="empoweringCaregiver" />
                </div> */}

                <div className="row w-100 empower-bgcolor align-items-center mt-5">
                    <div className="col-md-6">
                        <div className='ms-4'>
                            <div className="fs-2  fw-bold overall-text-color  empowerTextrespo">
                                Empowering Caregiver Support
                            </div>
                            <div className='fs-5 mt-2 empowerTextrespotext'>
                                Easily monitor your loved one's health and progress. Collaborate seamlessly with caregivers for personalized support and guidance.
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 p-0 text-end mt-5">
                        <img
                            className="responsiveImg-empowering"
                            src={empowerIphone}
                            alt="empoweringCaregiver"
                        />
                    </div>
                </div>




                <div>

                    <div className='text-center find-vizzhytext effortVizzhyheight fw-bold'>
                        Find Vizzhy on your favorite devices
                    </div>

                    <div className="row justify-content-center m-auto find-vizzhywidth mt-5 align-items-center">
                        <div className="col-6 col-md-3 text-center d-flex flex-column align-items-center ">
                            <img className='findVizzhyImages' src={smartPhone} alt="smartPhone" />
                            <p className="mt-2">Phone</p>
                        </div>
                        <div className="col-6 col-md-3 text-center d-flex flex-column align-items-center ">
                            <img className='findVizzhyImages' src={tablet} alt="tablet" />
                            <p className="mt-2">Tab</p>
                        </div>
                        <div className="col-6 col-md-3 text-center d-flex flex-column align-items-center ">
                            <img className='findVizzhyImages' src={smartWatch} alt="smartWatch" />
                            <p className='mt-2'>Smart Watch</p>
                        </div>
                        <div className="col-6 col-md-3 text-center d-flex flex-column align-items-center ">
                            <img className='findVizzhyImages' src={smartRing} alt="smartRing" />
                            <p className='mt-2'>Smart Ring</p>
                        </div>
                    </div>


                    <div className='text-center find-vizzhyDesc fw-bold mt-5 mx-2'>
                        for seamless health tracking and personalized insights anytime, anywhere.
                    </div>

                </div>


                <div className=' who-we-are-bg effortVizzhyheight'>
                    <div className=''>
                        <div className='container mt-4'>
                            <div className='fs-1 w-100 fw-bold missionandvisiontextcolor'>FAQ</div>
                            <div className="accordion mt-5" id="accordionExample">
                                {questionsAndAnswers.map((item, index) => (
                                    <div className="accordion-item " key={index}>
                                        <div>
                                            <h2 className="accordion-header" id={`heading${index}`}>
                                                <button
                                                    className="accordion-button "
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapse${index}`}
                                                    aria-expanded={openIndex === index}
                                                    aria-controls={`collapse${index}`}
                                                    onClick={() => toggleAccordion(index)}
                                                >
                                                    <span>
                                                        <img
                                                            src={openIndex === index ? cancel : plus}
                                                            alt="toggle-icon"
                                                        />
                                                    </span>{" "}<span className='question-question' >{item.question}</span>

                                                </button>
                                            </h2>
                                        </div>

                                        <div
                                            id={`collapse${index}`}
                                            className={`accordion-collapse collapse ${openIndex === index ? "show" : ""
                                                }`}
                                            aria-labelledby={`heading${index}`}
                                            data-bs-parent="#accordionExample"
                                        >
                                            <div className="accordion-body p-4 answer-marginstart ">
                                                <div className='answer-bground question-answer p-3 rounded-4 shadow-sm' style={{ color: "rgb(107, 95, 95)" }} >{item.answer}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}

export default EmpoweringCaregiverSupport